import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = (withImage) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
          background: theme.palette.secondary.dark,
          opacity: 0.7,
          zIndex: 2,
          [theme.breakpoints.up('md')]: {
            width: '70%',
            background: 'linear-gradient(90deg, #1B1925 0%, rgba(27, 25, 37, 0.0001) 100%)',
            opacity: 1,
          },
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: withImage ? '100%' : 370,
          left: 0,
          bottom: -1,
          background: 'linear-gradient(0deg, #1B1925 0%, rgba(27, 25, 37, 0.0001) 100%)',
        },
      },
      defaultBackground: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background:
          'radial-gradient(82% 64.09% at 50% 50%, rgba(134, 134, 241, 0.396078) 0%, rgba(166, 255, 246, 0.4) 100%)',
      },
      imageWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      },
      img: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      contentWrapper: {
        paddingTop: 100,
        paddingBottom: LARGE_MARGIN,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 2,
        position: 'relative',
        [theme.breakpoints.up('md')]: {
          paddingTop: 200,
          paddingBottom: LARGE_MARGIN,
        },
      },
      title: {
        lineHeight: 1.2,
        fontSize: 32,
        fontWeight: 'bold',
        marginBottom: MIDDLE_MARGIN,
        color: colorsPalette.white,
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
          fontSize: 40,
        },
      },
    }),
  );

export const useCommonHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    centeredContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    search: {
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: SMALL_MARGIN,
      },
    },
    searchTitle: {
      color: colorsPalette.white,
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 0,
      lineHeight: 1.2,
      textAlign: 'left',
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
      },
    },
    searchSubtitle: {
      fontSize: 18,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
    searchDescription: {
      fontSize: 18,
      color: colorsPalette.graySecondary,
      lineHeight: 1.5,
      marginTop: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        width: 850,
        maxWidth: '100%',
        marginTop: MIDDLE_MARGIN,
      },
    },
    wrapperWithBorder: {
      paddingBottom: MIDDLE_MARGIN,
      marginBottom: MIDDLE_MARGIN,
      position: 'relative',
      '&:after': {
        position: 'absolute',
        display: 'block',
        content: '""',
        height: 3,
        width: '100%',
        backgroundColor: colorsPalette.violet,
        opacity: 0.3,
        left: 0,
        bottom: 0,
      },
      [theme.breakpoints.up('md')]: {
        marginBottom: LARGE_MARGIN,
      },
    },
  }),
);

export default useStyles;
